import { render, staticRenderFns } from "./Battles.vue?vue&type=template&id=4df1a2eb&scoped=true"
import script from "./Battles.vue?vue&type=script&lang=js"
export * from "./Battles.vue?vue&type=script&lang=js"
import style0 from "./Battles.vue?vue&type=style&index=0&id=4df1a2eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df1a2eb",
  null
  
)

export default component.exports